const state = {
  display: false,
  type: ''
}

const mutations = {
  showInfo (state) {
    state.display = true
  },
  hideInfo () {
    state.display = false
  },
  typeVerschil (state) {
    state.type = 'verschil'
  },
  typeNormaal (state) {
    state.type = 'normaal'
  },
  typeAbsoluut (state) {
    state.type = 'absoluut'
  },
  typeIndex (state) {
    state.type = 'index'
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
